// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"9c3fc306","938":"e663ae0e"}[chunkId] + ".chunk.js";
};